<template>
  <div id="myAdvisory">
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form
          ref="form"
          :model="queryParams"
          label-width="80px"
          size="small"
        >
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="问题状态：" prop="questionStatus">
                <el-select clearable v-model="queryParams.questionStatus">
                  <template v-for="(value, key) in dictData['question_status']">
                     <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="反馈时间：" prop="time">
                <el-date-picker
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow:hidden;">
        <span style="float:left;">
          <el-button type="primary" size="small" @click="handleShowEdit({})"
            >新增</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table :data="tableData">
        <el-table-column width="170px" label="问题编号" prop="questionId"> </el-table-column>
        <el-table-column
          label="功能模板/页面"
          prop="questionTitle"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="问题与建议描述"
          prop="questionContent"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="附件信息"
          prop="attachUrl"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a
              v-if="scope.row.attachUrl"
              :href="scope.row.attachUrl"
              target="blank"
              >下载附件</a
            >
          </template>
        </el-table-column>
        <el-table-column label="问题状态" prop="questionStatus">
          <template slot-scope="scope">
            <span>{{
              dictMap["question_status"][scope.row.questionStatus]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="反馈时间" prop="operTime"></el-table-column>
        <el-table-column
          label="回复内容"
          prop="replyContent"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>


    
    <el-dialog :close-on-click-modal="false"  
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
    >
      <el-form
        :model="editDialog.advisoryForm"
        :rules="editDialog.rules"
        ref="advisoryForm"
        label-width="140px"
      >
        <el-form-item label="功能模板/页面" prop="questionTitle">
          <el-input v-model="editDialog.advisoryForm.questionTitle"></el-input>
        </el-form-item>
        <el-form-item label="问题与建议描述" prop="questionContent">
          <textarea
            v-model="editDialog.advisoryForm.questionContent"
            style="width:100%"
            rows="10"
          ></textarea>
        </el-form-item>
        <el-form-item label="上传附件" prop="">
          <el-upload
            ref="upload"
            action="#"
            :file-list="editDialog.fileList"
            :auto-upload="false"
            :on-change="handleChange"
            :multiple="false"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选择文件</el-button
            >
            <div slot="tip" class="el-upload__tip">
              文件小于20M,如果有多个文件，可将其压缩成.zip文件上传
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSaveQuestion"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/common/Breadcrumb'
import {
  getQuestionList,
  addQuestion,
  updateQuestion,
  deleteQuestion,
} from '@/api/sysSupport/question'
import { uploadFile } from "@/api/upload/upload"

export default {
  name: "CollectionBox",
  components: { Breadcrumb },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        questionStatus: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      total: 0,
      tableData: [],


      editDialog: {
        title: '',
        dialogVisible: false,
        advisoryForm: {
        },
        fileList: [],
        rules: {
          questionType: [
            { required: true, message: '请选择问题类型', trigger: 'blur' },
          ],
          questionTitle: [
            { required: true, message: '请输入问题标题', trigger: 'blur' },
          ],
          questionContent: [
            { required: true, message: '请输入问题与建议描述 ', trigger: 'blur' },
          ],
          questionStatus: [
            { required: true, message: '请选择问题状态', trigger: 'blur' },
          ],
          isTop: [
            { required: true, message: '请选择是否置顶', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapGetters(['dictData', 'dictMap']),
  },
  created() {
    this.loadData()
  },
  methods: {
    /** 查询问题列表 */
    loadData() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = this._.clone(this.queryParams)
      delete params['time']
      getQuestionList(params).then((response) => {
        this.tableData = response.rows
        this.total = response.total
        this.endLoading()
      }).catch(()=>{
        this.endLoading() 
      })
    },

    resetForm() {
      this.$refs['form'].resetFields()
    },
    handleChange(file, fileList) {
      if(file.size > 20*1024*1024){
        this.msgWarning("文件不能大于20M")
          this.editDialog.fileList = []
      }else{
        this.editDialog.fileList = [file]
      }
    },
    /**显示编辑页面 */
    handleShowEdit(row) {
      if (row.questionId) {
        this.editDialog.advisoryForm = Object.assign({}, row)
        this.editDialog.title = '编辑问题'
      } else {
        this.editDialog.advisoryForm = { isTop: '0' }
        this.editDialog.title = '新增问题'
      }
      this.editDialog.dialogVisible = true
      // this.editor.setData(row.content)
    },

    /**保存问题信息 */
    handleSaveQuestion() {
      this.$refs['advisoryForm'].validate(async (valid) => {
        if (valid) {
            this.startLoading()
            //开始上传文件
            if(this.editDialog.fileList.length > 0){
              const { uploadFlag, fileUrl } = await uploadFile(this.editDialog.fileList[0])
              if (!uploadFlag) {
                _self.msgError("上传失败！")
                this.endLoading()
                return
              }
              this.editDialog.advisoryForm.attachUrl = fileUrl
            }

            if (this.editDialog.advisoryForm.questionId) {
              updateQuestion(this.editDialog.advisoryForm).then((response) => {
                if (response.code == '200') {
                  this.$message.success('修改成功！')
                  this.editDialog.dialogVisible = false
                  this.endLoading()
                  this.loadData()
                } else {
                  this.endLoading()
                  this.$message.error('修改失败')
                }
              })
            } else {
              addQuestion(this.editDialog.advisoryForm).then((response) => {
                if (response.code == '200') {
                  this.$message.success('新增成功！')
                  this.endLoading()
                  this.editDialog.dialogVisible = false
                  this.loadData()
                } else {
                  this.endLoading()
                  this.$message.error('新增失败')
                }
              })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    /**删除问题 */
    handleDeleteQuestion(row) {
      this.$confirm('确认删除问题？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteQuestion(row).then((response) => {
          if (response.code == '200') {
            this.$message.success('删除成功！')
            this.loadData()
          } else {
            this.$message.error('删除失败！')
          }
        })
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
